import { Locale } from "@redotech/crdb-enums/common/locale";
import { TranslatableInstructionMethodSchema } from "@redotech/redo-return-settings-common/packing-instruction-return-method";
import * as z from "zod";
import { ReturnInstructionTranslationSetSchema } from "./return-instruction-translation-sets";

/** Stores the merchant's approved translation of one locale, one line per instruction step. */
export const approveReturnInstructionTranslation = {
  name: "approveReturnInstructionTranslation" as const,
  input: z.object({
    instructionSet: TranslatableInstructionMethodSchema,
    locale: z.enum(Locale),
    instructions: z.array(z.string().max(2000)).max(50),
    /** The instructions as the merchant saw them; a mismatch is rejected as a conflict. */
    sourceInstructions: z.array(z.string()).max(50),
    /** The AI draft the merchant reviewed; lines approved unchanged are recorded as AI-written. */
    aiInstructions: z.array(z.string().max(2000)).max(50).optional(),
  }),
  output: z.object({ sets: z.array(ReturnInstructionTranslationSetSchema) }),
};
